import { t } from "@/i18n-js/instance";
import { CommunityLogo } from "@circle-react/components/shared/CommunityLogo";
import { usePunditUserContext } from "@circle-react/contexts";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useThemeContext } from "@circle-react/providers";
import { Icon } from "@circle-react-shared/Icon";
import "./styles.scss";

export interface FullScreenTopbarProps {
  actions: React.ReactNode;
  buttonPosition?: "start" | "end";
  onClose: () => void;
  showCommunityIcon?: boolean;
}

export const FullScreenTopbar = ({
  onClose,
  actions,
  buttonPosition = "end",
  showCommunityIcon = true,
}: FullScreenTopbarProps) => {
  const { currentCommunity } = usePunditUserContext();
  const { isDarkAppearance } = useThemeContext();

  const brandColor = isDarkAppearance
    ? currentCommunity?.prefs.brand_color.dark
    : currentCommunity?.prefs.brand_color.light;

  const brandTextColor = isDarkAppearance
    ? currentCommunity?.prefs.brand_text_color.dark
    : currentCommunity?.prefs.brand_text_color.light;

  return (
    <div
      className={classNames("react-layout-fullscreen-topbar", {
        "react-layout-fullscreen-topbar--reverse": buttonPosition === "start",
      })}
    >
      {showCommunityIcon && currentCommunity && (
        <div className="react-layout-fullscreen-topbar__community-icon">
          <CommunityLogo
            brand_color={brandColor}
            brand_text_color={brandTextColor}
            {...currentCommunity}
          />
        </div>
      )}
      <div className="react-layout-fullscreen-topbar__actions">{actions}</div>
      <button type="submit" className="btn-close" onClick={onClose}>
        <Icon type="close" />
        <span className="sr-only">{t("full_screen_layout.close_panel")}</span>
      </button>
    </div>
  );
};
